export default "__VITE_ASSET__ohGULQEX__"